import {useDiscipline} from "@/hooks/useDiscipline";
import {disciplinaryModalAtom} from "@/store/jotaiAtoms";
import {getDisciplineColor} from "@/utils/disciplineUtils";
import {useAtomValue} from "jotai";
import {isEmpty} from "lodash";
import {memo, useMemo, type FC} from "react";
import {useTranslation} from "react-i18next";

const InfoboxSection: FC = () => {
  const {disciplineTabInPunishmentType, getLabelByDisciplineType, isStrongerDisciplineActive} = useDiscipline();
  const {t} = useTranslation("influencer_discipline");
  const {lastDiscipline} = useAtomValue(disciplinaryModalAtom);

  const infoBox = useMemo(() => {
    const messages: string[] = [];

    if (lastDiscipline?.punishment_type === disciplineTabInPunishmentType) {
      messages.push(
        t("info_discipline_active", {
          discipline: getLabelByDisciplineType(lastDiscipline.punishment_type),
          part_two: lastDiscipline.punishment_type !== "PERMANENT_BAN" ? t("info_discipline_active_part_2") : ".",
        }),
      );
    }

    if (isStrongerDisciplineActive && lastDiscipline?.punishment_type) {
      messages.push(
        t("info_stronger_discipline_active", {
          discipline: getLabelByDisciplineType(lastDiscipline.punishment_type),
        }),
      );
    }

    return messages;
  }, [disciplineTabInPunishmentType, getLabelByDisciplineType, lastDiscipline?.punishment_type]);

  if (isEmpty(infoBox) || !lastDiscipline) {
    return null;
  }

  return (
    <div className="flex flex-col gap-5">
      {infoBox.map((info, index) => (
        <div
          key={index}
          className="bg-neutral-grey-lightest border-neutral-grey-light-dark rounded-md border px-5 py-5.5">
          <span
            className="flex justify-center text-sm font-semibold"
            style={{color: `var(--color-${getDisciplineColor(lastDiscipline.punishment_type)})`}}>
            {info}
          </span>
        </div>
      ))}
    </div>
  );
};

export default memo(InfoboxSection);
